import { render, staticRenderFns } from "./PrivilegeMain.vue?vue&type=template&id=95395aa6"
import script from "./PrivilegeMain.vue?vue&type=script&lang=js"
export * from "./PrivilegeMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports